import {
  Button,
  Col,
  Edit,
  Form,
  Input,
  Row,
  SaveButton,
  Select,
  useForm
} from "@pankod/refine-antd";
import {
  IResourceComponentsProps,
  useNavigation,
  useNotification,
  useCustomMutation,
  useApiUrl,
} from "@pankod/refine-core";
import { PasswordRevealModal } from "components/modals";
import { useInfiniteSelect } from "hooks/useInfiniteSelect";
import { IPartnerUser } from "interfaces";
import { FC, useState } from "react";
import { extractApiErrorMessage } from "utils/utils";

export const PartnerUsersEdit: FC<IResourceComponentsProps> = () => {
  const { goBack } = useNavigation();
  const { open } = useNotification();
  const apiUrl = useApiUrl();
  const [generatedPassword, setGeneratedPassword] = useState<string | null>(null);

  const { formProps, saveButtonProps, queryResult } = useForm<IPartnerUser>({
    errorNotification: false,
    onMutationError: (error) => {
      const message = extractApiErrorMessage(error);
      open?.({
        type: "error",
        description: "Erro ao atualizar usuário parceiro!",
        message,
      });
    },
  });

  const partnerId = queryResult?.data?.data?.id;

  const { selectProps: partnerSelectProps } = useInfiniteSelect({
    resource: "v1/partners",
    optionLabel: "partner_name",
    optionValue: "partner_code",
    sort: [{ field: "partner_name", order: "asc" }]
  });

  const { mutate: resetPassword, isLoading: resetting } = useCustomMutation();

  const handleResetPassword = () => {
    if (!partnerId) return;
    resetPassword(
      {
        url: `${apiUrl}/v1/partner-users/${partnerId}/reset-password`,
        method: "post",
        values: {},
        successNotification: false,
        errorNotification: false,
      },
      {
        onSuccess: (data) => {
          const password = (data.data as IPartnerUser).generated_password;
          if (password) setGeneratedPassword(password);
        },
        onError: (error) => {
          const message = extractApiErrorMessage(error);
          open?.({
            type: "error",
            description: "Erro ao resetar senha!",
            message,
          });
        },
      }
    );
  };

  return (
    <>
      <Edit
        title="Editar Usuário Parceiro"
        headerButtons={[
          <Button
            key="reset-password"
            danger
            loading={resetting}
            onClick={handleResetPassword}
            disabled={!partnerId}
          >
            Resetar Senha
          </Button>,
        ]}
        footerButtons={() => (
          <Row gutter={16}>
            <Col>
              <Button onClick={() => goBack()} style={{ minWidth: "92px" }}>
                Cancelar
              </Button>
            </Col>
            <Col>
              <SaveButton {...saveButtonProps} icon={null} style={{ minWidth: "92px" }}>
                Salvar
              </SaveButton>
            </Col>
          </Row>
        )}
      >
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              { required: true, whitespace: true, message: "Informe o nome" },
            ]}
          >
            <Input placeholder="Nome completo" />
          </Form.Item>

          <Form.Item label="Username" name="username">
            <Input disabled />
          </Form.Item>

          <Form.Item label="Parceiros" name="partners">
            <Select
              {...partnerSelectProps}
              mode="multiple"
              placeholder="Selecione os parceiros"
            />
          </Form.Item>

          <Form.Item label="Status" name="status">
            <Select
              options={[
                { label: "Ativo", value: "active" },
                { label: "Inativo", value: "inactive" },
              ]}
            />
          </Form.Item>
        </Form>
      </Edit>

      <PasswordRevealModal
        open={Boolean(generatedPassword)}
        password={generatedPassword ?? ""}
        onClose={() => setGeneratedPassword(null)}
      />
    </>
  );
};
